module.exports = __webpack_public_path__ + "media/components/country-flag/static/au-786508c11e6e2b83d179bd8d25243799.svg";